<template>
  <div class="modal fade" id="branchTerminalCreateUpdateModel" tabindex="-1" aria-labelledby="branchTerminalCreateUpdateModelLabel" aria-hidden="true" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!loaded">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="branchTerminalCreateUpdateModelLabel">
            <span v-if="modalData.title" class="text-gray-600" v-html="modalData.title"></span>
            <span v-else class="text-gray-600">Новый терминал (касса)</span>
          </h5>
          <button @click="clearForm" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div v-if="error" class="alert alert-danger d-flex align-items-center p-5">
            <span v-html="error"></span>
          </div>
          <input-field
              v-model="this.form.terminal"
              id="form.terminal.terminal"
              name="form.terminal.terminal"
              :required="true"
              :mb="5"
              placeholder="Терминал"
              type="text"
          />
          <input-field
              v-model="this.form.login"
              id="form.terminal.login"
              name="form.terminal.login"
              :required="true"
              :mb="5"
              placeholder="Логин"
              type="text"
          />
          <input-field
              v-model="this.form.password"
              id="form.terminal.password"
              name="form.terminal.password"
              :required="true"
              :mb="5"
              placeholder="Пароль"
              type="text"
          />
          <div class="custom-select dynamic" v-if="this.directory.accountants">
            <label for="form.accountant_id">Бухгалтер</label>
            <v-select
                v-model="form.accountant_id"
                input-id="form.accountant_id"
                :options="this.directory.accountants"
                :reduce="item => item.id"
                :required="true"
                placeholder="Выберите..."
                class="mb-5 bg-gray-100 form rounded"
                label="name"
            />
          </div>
          <select-field-from-model
              v-model="this.form.status"
              id="form.terminal.status"
              name="form.terminal.status"
              :options="[{id: 0, name: 'Неактивный'},{id: 1, name: 'Активный'}]"
              :required="true"
              placeholder="Статус"
          />
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button
              type="button"
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
          >Закрыть</button>
          <div class="d-flex">
            <button
                @click="checkAuthorization"
                :disabled="!this.form.password || !this.form.login || !this.form.terminal"
                type="button"
                class="btn btn-sm btn-primary me-2"
            >Проверить авторизацию</button>
            <button
                @click="addTerminal"
                :disabled="!this.form.terminal.length > 5"
                type="button"
                class="btn btn-sm btn-primary"
            >Сохранить</button>
          </div>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="min-height: 319px"/>
      </div>
    </div>
  </div>
</template>

<script>
import SelectFieldFromModel from '@/components/Fields/SelectFieldFromModel'
import InputField           from '@/components/Fields/InputField'
import LoaderFull           from '@/components/Main/LoaderFull'
import vSelect              from "vue-select";
import axios                from 'axios'

export default {
  name: 'BranchTerminalCreateUpdateModel',
  components: { vSelect, SelectFieldFromModel, LoaderFull, InputField },
  data() {
    return {
      loaded:        false,
      error:         null,
      form: {
        accountant_id:  null,
        terminal:       '',
        password:       '',
        status:         1,
        login:          '',
      },
      directory: {
        accountants: [],
        branches:    []
      },
    }
  },
  computed: {
    modalData() { return this.$store.getters.getBranchTerminalCreateUpdateModel }
  },
  methods: {
    addTerminal() {
      this.loaded = true
      const data  = {form:this.form, isEdit: this.modalData.isEdit, id:this.modalData.id}
      axios.post('/api/branches/change-terminal', data)
          .then(res => {
            if (res.data.result) {
              this.$store.dispatch('terminalsRequest')
              this.modalHidden()
            } else {
              this.error = res.data.message
            }
          })
          .catch(err => {
            if (err.response) {
              this.error = err.response.data.message
            } else {
              this.error = err.message
            }
          })
          .finally(() => this.loaded = false)
    },
    checkAuthorization() {
      this.loaded = true
      const data  = {terminal:this.form}
      axios.post('/api/branches/check-terminal', data)
          .then(res => {
            if (res.data.result) {
              this.$notifySuccess({message: 'Авторизация прошла успешно'}, {title: 'Успешно'})
            } else {
              this.$notifyError(res.data, {title: 'Ошибка'})
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => this.loaded = false)
    },
    clearForm() {
      this.form = {
        terminal:   '',
        status:     1,
      }
      this.loaded        = false
      this.error         = null
    },
    getItem(id, isEdit) {
      this.loaded = true
      axios.post('/api/branches/terminal-item', {id:id, isEdit: isEdit})
          .then(res => {
            if (res.data.result) {
              if (isEdit) {
                this.form = res.data.data.terminal
              }
              this.directory.accountants = res.data.data.accountants
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {this.loaded = false})
    },
    modalHidden() {
      const myModalEl = document.getElementById('branchTerminalCreateUpdateModel');
      const modal = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
      this.clearForm()
    }
  },
  watch: {
    form: {
      deep: true,
      handler(newValue) {
        if (newValue) this.error = null
      }
    },
    modalData: {
      deep: true,
      handler(newValue) {
        this.clearForm()
        this.getItem(newValue.id, newValue.isEdit)
      }
    }
  }
}
</script>

<style scoped>

</style>